export default __webpack_public_path__ + "static/media/2.a2081c70.png";